<template>
  <div>
    <Head title="Campaign Planning" />
    <h1 class="mb-4 text-xl font-bold">
      <Link class="text-indigo-400 hover:text-indigo-600" href="/campaigns">Campaign</Link>&nbsp;
      <span class="text-indigo-400 font-medium">/</span>
      {{ campaign.name }}
    </h1>
    <div ref="map" class="w-full" :style="{ height: mapHeight }" />
  </div>
</template>

<script>
import { Head, Link } from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import { ref, onMounted, computed } from 'vue'

export default {
  components: {
    Head,
    Link,
  },
  layout: Layout,
  props: {
    campaign: {
      type: Object,
      required: true,
    },
  },
  setup(props) {
    const map = ref(null)

    const mapHeight = computed(() => {
      const screenHeight = window.innerHeight
      //console.log(screenHeight)
      // Subtract any additional offsets if needed
      const offset = screenHeight > 600 ? 250 : 100
      return `${screenHeight - offset}px`
    })

    const loadGoogleMaps = () => {
      return new Promise((resolve, reject) => {
        const googleMapsScript = document.createElement('script')
        googleMapsScript.src = 'https://maps.googleapis.com/maps/api/js?key=AIzaSyBC9PpRj_GiHGB3v8wHRHN9ec_V6xsw_wQ&libraries=places'
        googleMapsScript.async = true
        googleMapsScript.defer = true
        googleMapsScript.onload = () => {
          // Load MarkerClusterer library after Google Maps API is loaded
          const markerClustererScript = document.createElement('script')
          markerClustererScript.src = 'https://cdnjs.cloudflare.com/ajax/libs/js-marker-clusterer/1.0.0/markerclusterer.js'
          markerClustererScript.async = true
          markerClustererScript.defer = true
          markerClustererScript.onload = resolve
          markerClustererScript.onerror = reject
          window.document.body.appendChild(markerClustererScript)
        }
        googleMapsScript.onerror = reject
        window.document.body.appendChild(googleMapsScript)
      })
    }

    onMounted(async () => {
      await loadGoogleMaps()

      if (typeof google === 'undefined') {
        console.error('Google Maps API failed to load.')
        return
      }

      const initializeMap = () => {
        const validDetails = props.campaign.campaign_details.filter((detail) => parseFloat(detail.latitude) !== 0 && parseFloat(detail.longitude) !== 0)

        if (validDetails.length === 0) {
          console.error('No valid latitude/longitude data available.')
          return
        }

        const mapOptions = {
          zoom: 10,
        }

        const googleMap = new google.maps.Map(map.value, mapOptions)
        const bounds = new google.maps.LatLngBounds()
        const markers = []

        validDetails.forEach((detail) => {
          const markerPosition = { lat: parseFloat(detail.latitude), lng: parseFloat(detail.longitude) }
          const marker = new google.maps.Marker({
            position: markerPosition,
            map: googleMap,
            title: detail.note,
          })

          const infoWindowContent = `
              <div>
                  <p>Meta Information:</p>
                  <ul>
                    <li>
                        Address: ${detail.from_ch ? detail.from_ch : '-'}
                    </li>
                    <li>
                        Note:  ${detail.note ? detail.note : '-'}
                    </li>
                  </ul>
              </div>
              `

          const infoWindow = new google.maps.InfoWindow({
            content: infoWindowContent,
          })

          marker.addListener('click', () => {
            infoWindow.open(googleMap, marker)
          })

          bounds.extend(markerPosition)
          markers.push(marker)
        })

        googleMap.fitBounds(bounds)

        const markerCluster = new MarkerClusterer(googleMap, markers, {
          imagePath: 'https://developers.google.com/maps/documentation/javascript/examples/markerclusterer/m',
          gridSize: 40,
          minimumClusterSize: 2,
          maxZoom: 17,
        })
      }
      initializeMap()
    })

    return {
      map,
      mapHeight,
    }
  },
}
</script>
